import { render, staticRenderFns } from "./Form.vue?vue&type=template&id=1953bf16&scoped=true"
import script from "./Form.vue?vue&type=script&lang=js"
export * from "./Form.vue?vue&type=script&lang=js"
import style0 from "./Form.vue?vue&type=style&index=0&id=1953bf16&prod&lang=scss&scoped=true"
import style1 from "./Form.vue?vue&type=style&index=1&id=1953bf16&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1953bf16",
  null
  
)

export default component.exports